import { render, staticRenderFns } from "./changePkgGroup.vue?vue&type=template&id=7088d8f7&scoped=true&"
import script from "./changePkgGroup.vue?vue&type=script&lang=js&"
export * from "./changePkgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088d8f7",
  null
  
)

export default component.exports